<template>
  <responsive-modal v-model="visible" title="Integrar LeadLovers">
    <div class="tool-modal-leadlovers">
      <a
        href="https://www.leadlovers.com/"
        target="_blank"
        class="integration-link"
      >
        Conheça a LeadLovers
        <i class="ph ph-arrow-square-out" />
      </a>
      <snow-input
        label="Token"
        id="token"
        v-model="form.token"
        :errors="errors.token"
      />
      <snow-input
        label="Descrição da integração"
        id="description"
        v-model="form.description"
        :errors="errors.description"
      />
      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="visible = false"
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["description", "status", "token"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    isValid() {
      return this.form.description && this.form.token;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.visible = false;
      this.clear();
    },
    submit() {
      this.loading = true;

      const data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("A integração foi salva!");
          this.$emit("update-list");
          this.onSubmit();
        })
        .catch(() => {
          this.$message.error("Erro ao salvar integração");
          this.onSubmit();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-leadlovers {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
